import { render, staticRenderFns } from "./CreateEditSchool.vue?vue&type=template&id=35871d5a&scoped=true&"
import script from "./CreateEditSchool.vue?vue&type=script&lang=js&"
export * from "./CreateEditSchool.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35871d5a",
  null
  
)

export default component.exports